define('customPlugins/atnElement',[
        'knockout', 'lodash', 'jquery'
    ],
    function(ko, _, $) {
        'use strict';
        /**
         * Created for taking reference of the given element for future use.
         * It is actually a bypass created for directly accessing the HTML element itself into observable
         * @type {Object}
         */
        ko.bindingHandlers.atnElement = {
            init: function(element, valueAccessor) {
                var value = valueAccessor();
                value(element);
            }
        };
    });
